<script lang="ts">
  interface UserTrack {
    id: number;
    duel_id: number;
    track_type: string;
    name: string;
    duel_name: string;
    genre_name: string;
    votes: number;
    listens: number;
    rank: number;
    total_tracks: number;
    end_vote: string;
    created_at: string;
  }

  let { tracks }: { tracks: UserTrack[] } = $props();
</script>

{#if tracks.length > 0}
  <div class="section">
    <h2>Recent Tracks</h2>
    <div class="table-scroll">
      <table class="data-table">
        <thead><tr><th>Track</th><th>Duel</th><th>Genre</th><th>Votes</th><th>Rank</th></tr></thead>
        <tbody>
          {#each tracks as track}
            <tr>
              <td><a href="#/tracks/{track.id}">{track.name || 'Track #' + track.id}</a></td>
              <td class="muted"><a href="#/duels/{track.duel_id}/result">{track.duel_name}</a></td>
              <td class="muted">{track.genre_name}</td>
              <td class="muted">{track.votes}</td>
              <td
                class:rank-gold={track.rank === 1}
                class:rank-silver={track.rank === 2}
                class:rank-bronze={track.rank === 3}
              >
                {#if track.rank}#{track.rank}<span class="of-count"> / {track.total_tracks}</span>{:else}&mdash;{/if}
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </div>
{/if}

<style>
  .section {
    margin-top: 2rem;
  }
  .section h2 {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  .table-scroll {
    overflow-x: auto;
  }
  .data-table {
    width: 100%;
    font-size: 0.875rem;
    border-collapse: collapse;
  }
  .data-table th {
    text-align: left;
    padding-bottom: 0.5rem;
    color: var(--text-muted);
    font-weight: 500;
    border-bottom: 1px solid var(--border);
  }
  .data-table td {
    padding: 0.5rem 0;
    border-bottom: 1px solid rgba(42, 42, 42, 0.5);
  }
  .data-table a {
    color: var(--cyan);
    text-decoration: none;
  }
  .data-table a:hover {
    text-decoration: underline;
  }
  .muted {
    color: var(--text-secondary);
  }
  .rank-gold {
    color: var(--gold, #ffd700);
    font-weight: 700;
  }
  .rank-silver {
    color: #c0c0c0;
    font-weight: 600;
  }
  .rank-bronze {
    color: #cd7f32;
    font-weight: 600;
  }
  .of-count {
    font-size: 0.75rem;
    color: var(--text-muted);
  }
</style>
